import React from 'react';
import { Clear } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { InsightDispatch } from '../../redux/store';

const CloseFlyout = function CloseFlyout(): React.ReactElement {
  const dispatch = useDispatch<InsightDispatch>();
  const onClick = function handleOnClick(): void {
    dispatch.flyout.toggleOpen();
  };

  return <Clear onClick={onClick} />;
};

export default CloseFlyout;
